<template>
  <el-card class="box-card clearfix main-card">
    <el-button v-if="$route.query.userId" size="mini" class="pxy-primary return-button" style="margin-right: 10px;" @click="$router.go(-1)">返回</el-button>
    <template>
      <el-row v-if="$route.query.userId" style="margin-bottom: 20px;">
        <span>用户名称：</span>
        <el-tag effect="plain">{{$route.query.userName}}</el-tag>
      </el-row>
      <el-table
        :data="userVoucherList"
        style="width: 100%">
        <el-table-column
          prop="voucherName"
          label="来源">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="总金额">
        </el-table-column>
        <el-table-column
          prop="balance"
          label="剩余金额">
        </el-table-column>

        <el-table-column
          label="开始日期">
          <template slot-scope="scope">
            <span > {{scope.row.startDate | formatDate}}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createDate"
          label="结束日期">
          <template slot-scope="scope">
            {{scope.row.endDate | formatDate}}
          </template>
        </el-table-column>

      </el-table>
    </template>
    <PageComponent ref="pageInfo"></PageComponent>
    <!-- <PageComponent :currentPage="pageObj.currentPage" :total="pageObj.total" :pageSize="pageObj.pageSize" @handlePageChange="handlePageChange"></PageComponent> -->
  </el-card>
</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";
  export default {
    components: {PageComponent},
    data() {
      return {
        userVoucherList:[],
        // pageObj: {
        //   currentPage: 1,
        //   total: '0',
        //   pageSize: 10
        // }
      }
    },
    created() {
    },
    methods: {
      getUserVoucher:function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        this.getRequest('/ofc/userVoucher/search', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userVoucherList = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            /*Message.error("error");*/
            console.error("error")
          }
        })
      },
      getUserCoupon() {
        var params = {
          page: this.$refs.pageInfo.currentPage,
          pageSize: 10,
          userId: this.$route.query.userId
        };
        this.getRequest('/dev/system/ofc/userVoucher/search', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userVoucherList = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      // handlePageChange(val) {
      //   var queryStr = JSON.parse(JSON.stringify(this.$route.query));
      //   queryStr.page = 1;
      //   this.$router.push({query: queryStr})
      //   this.pageObj.currentPage = val;
      //   if(this.$route.query.userId){ // 收支明细查询 - （用户管理菜单页跳转过来）
      //     this.getUserCoupon();
      //   } else {
      //     this.getUserVoucher()
      //   }
      // }
    },
    mounted: function () {
      if(this.$route.query.userId){ // 优惠券查询 - （用户管理菜单页跳转过来）
        this.$refs.pageInfo.initPagenator(this.getUserCoupon, 10);
        this.getUserCoupon();
      } else {
        this.$refs.pageInfo.initPagenator(this.getUserVoucher, 10);
        this.getUserVoucher();
      }
    },
    beforeDestroy() {

    }
  }
</script>

